import React from "react";
import PopUp from "../../components/base/popup";
export default PopUp;